import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Card } from "@/components/ui/card";
import { springPresets } from "@/lib/motion";

interface AdBannerProps {
  size: 'leaderboard' | 'rectangle' | 'skyscraper';
  position: string;
}

const sizeConfig = {
  leaderboard: {
    width: 'w-full',
    height: 'h-24',
    maxWidth: 'max-w-[728px]',
    aspectRatio: 'aspect-[728/90]',
  },
  rectangle: {
    width: 'w-full',
    height: 'h-64',
    maxWidth: 'max-w-[300px]',
    aspectRatio: 'aspect-[300/250]',
  },
  skyscraper: {
    width: 'w-full',
    height: 'h-[600px]',
    maxWidth: 'max-w-[160px]',
    aspectRatio: 'aspect-[160/600]',
  },
};

export function AdBanner({ size, position }: AdBannerProps) {
  const config = sizeConfig[size];

  const handleClick = () => {
    console.log(`Ad clicked: ${size} at ${position}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={springPresets.gentle}
      className={`${config.width} ${config.maxWidth} mx-auto`}
    >
      <Card
        className="overflow-hidden cursor-pointer group transition-all duration-200 hover:shadow-lg"
        onClick={handleClick}
      >
        <div
          className={`${config.height} ${config.aspectRatio} bg-gradient-to-br from-muted via-muted/80 to-muted/60 flex flex-col items-center justify-center p-4 relative`}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
          
          <div className="relative z-10 text-center space-y-2">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-2">
              <ExternalLink className="w-6 h-6 text-primary" />
            </div>
            
            <p className="text-sm font-semibold text-foreground">
              Advertisement Space
            </p>
            
            <p className="text-xs text-muted-foreground">
              {size === 'leaderboard' && '728 x 90'}
              {size === 'rectangle' && '300 x 250'}
              {size === 'skyscraper' && '160 x 600'}
            </p>
            
            <div className="pt-2">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
                {position}
              </span>
            </div>
          </div>

          <div className="absolute bottom-2 right-2 text-[10px] text-muted-foreground/50">
            Ad
          </div>
        </div>
      </Card>
    </motion.div>
  );
}
